import { Card } from '@repo/shadcn';

import { HeaderBreadcrumb } from '@components/ui';
import { DataTable } from '@components/ui/data.table/data-table';
import { SectionError } from '@components/ui/error';
import PageHeading from '@components/ui/heading/page-headeing';
import { SectionLoader } from '@components/ui/loader';
import PaginationComponent from '@components/ui/pagination';

import { DEFAULT_PAGE_LIMIT, DEFAULT_PAGE_NUMBER, Route } from '@/constants';
import { useUrlPagination } from '@/hooks';
import { notificationListColumn } from '@/modules/notification/notification-list/column';
import { useNotificationList } from '@/modules/notification/notification-list/hook';

export const NotificationList = () => {
    const { data, isFetching, isError, isLoading, error } =
        useNotificationList();
    const { page, setCurrentPage } = useUrlPagination();

    if (isLoading) {
        return <SectionLoader />;
    }

    if (isError) {
        return <SectionError error={error} fallbackPath={Route.DASHBOARD} />;
    }

    return (
        <Card className={'space-y-4 p-4'}>
            <HeaderBreadcrumb
                showHomeLink={true}
                items={[
                    {
                        label: 'Notifications',
                        href: Route.NOTIFICATIONS,
                    },
                ]}
            />
            <PageHeading
                title={'Notifications'}
                subTitle={'View your notifications'}
            />

            <div>
                <DataTable
                    data={data?.data ?? []}
                    isLoading={isLoading || isFetching}
                    columns={notificationListColumn}
                />
                <p className="mt-3 flex w-full items-center px-4 text-right font-semibold">
                    Total Found : {data?.pagination?.total_items ?? 0}
                </p>
                <PaginationComponent
                    showTotalItems
                    totalItems={data?.pagination?.total_items ?? 0}
                    itemsPerPage={data?.pagination?.limit ?? DEFAULT_PAGE_LIMIT}
                    initialPage={
                        page ??
                        data?.pagination?.current_page ??
                        DEFAULT_PAGE_NUMBER
                    }
                    onPageChange={(p) => {
                        setCurrentPage(p);
                    }}
                />
            </div>
        </Card>
    );
};

NotificationList.displayName = 'Notification';
